<template>
  <i :class="`icon icon-${icon}`" aria-hidden="true"></i>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Icon',
  inheritAttrs: true,
  props: {
    icon: {
      type: String,
      required: true
    }
  }
});
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'playable-ui-campaignview';
  src:
    url('@/src/components/icons/font/playable-ui-campaignview.woff') format('woff'),
    url('@/src/components/icons/font/playable-ui-campaignview.ttf') format('truetype'),
    url('@/src/components/icons/font/playable-ui-campaignview.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}

[class^='icon-'],
[class*=' icon-'] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'playable-ui-campaignview' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-snapchat:before {
  content: '\ea5d';
}
.icon-tiktok:before {
  content: '\ea41';
}
.icon-pinterest:before {
  content: '\ea3e';
}
.icon-vimeo:before {
  content: '\ea3f';
}
.icon-x_logo:before {
  content: '\ea40';
}
.icon-messenger:before {
  content: '\ea5a';
}
.icon-facebook:before {
  content: '\eeef';
}
.icon-whatsapp:before {
  content: '\eef2';
}
.icon-linkedin:before {
  content: '\ef28';
}
.icon-globe:before {
  content: '\ea32';
}
.icon-home:before {
  content: '\ea2a';
}
.icon-instagram:before {
  content: '\ea26';
}
.icon-mail:before {
  content: '\e994';
}
.icon-message-circle:before {
  content: '\e99b';
}
.icon-youtube:before {
  content: '\ea16';
}
</style>
